<script setup lang="ts">
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { useFlowConfigStore } from '@/store/flow-config.store'
  import { computed } from 'vue'

  const store = useFlowConfigStore()
  const pageCount = computed(() => store.config?.pages.length ?? 0)
  const isFirst = computed(() => store.currentPage <= 0)
  const isLast = computed(() => store.currentPage >= pageCount.value - 1)

  function prev() {
    if (!isFirst.value) store.currentPage--
  }
  function next() {
    if (!isLast.value) store.currentPage++
  }
</script>

<template>
  <div class="page-nav">
    <UiButton
      class="nav-btn"
      :disabled="isFirst"
      @click="prev"
      icon="chevronLeft"
      :variant="isFirst ? 'default' : 'prominent'"
    />
    <UiButton class="nav-btn" @click="store.insertPage()" icon="plus" variant="prominent" />
    <UiButton
      class="nav-btn delete"
      :disabled="pageCount < 2"
      @click="store.removePage()"
      icon="delete"
      :variant="pageCount < 2 ? 'default' : 'negative'"
    />
    <UiButton
      class="nav-btn"
      :disabled="isLast"
      @click="next"
      icon="chevronRight"
      :variant="isLast ? 'default' : 'prominent'"
    />
  </div>
</template>

<style scoped>
  .page-nav {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    gap: var(--spacing-s);
  }
</style>
